import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import SuplentesGral from './../../../img/suplentesGral.png';
import VotacionCasilla from './../../../img/votacionCasilla.png';
import CasillaCerrada from './../../../img/casillaCerrada.png';
import PaqueteElectoral from './../../../img/paqueteElectoral.png';
import AccionesComunes from '../../AccionesComunes';

class EtapasJornada extends Component {

    componentDidMount(){
        var activeMenu = document.getElementById("jornadaElec");
        activeMenu.classList.add("active");
    }

    render () {
        return (
            <div className="container contenido">
                <AccionesComunes />
                <div className="migajas">
                    <small>
                        <Link to="./QueEsSIJE">Inicio</Link>
                        <span>Jornada Electoral</span>
                        <span>Etapas de la Jornada</span>
                    </small>
                </div>
                <div className="col-md-12 text-center mb-5">
                    <h1 className="tituloPagina">Etapas de la Jornada</h1>
                </div>

                <div className="row bordes">
                    <div className="col-md-12 text-center">
                        <h2>Instalación de casillas</h2>
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <div className="floatLF numerales">
                            <p>1</p>
                        </div>
                        <p>
                            El día de la jornada y previo a las 8:00am (hora local), los funcionarios de casilla acuden al sitio donde se ubicará la misma, y proceden a instalar la casilla.
                        </p>
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={SuplentesGral} alt="Funcionarios de casilla" />
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-12 text-center">
                        <h2>Desarrollo de la votación</h2>
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={VotacionCasilla} alt="Funcionarios de casilla" />
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <div className="floatLF height100 numerales">
                            <p>2</p>
                        </div>
                        <p>
                            A las 8:00am (hora local), las casillas abren para atender a los electores, y continúan abiertas hasta las 6:00pm (hora local).
                        </p>
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-12 text-center">
                        <h2>Cierre de la votación</h2>
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <div className="floatLF height100 numerales">
                            <p>3</p>
                        </div>
                        <p>
                            A las 6:00pm (hora local), se cierran las casillas; a menos que haya electores formados para votar. Los funcionarios de casilla llenan los apartados correspondientes en el Acta de la jornada electoral.
                        </p>
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={CasillaCerrada} alt="Funcionarios de casilla" />
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-12 text-center">
                        <h2>Escrutinio y cómputo</h2>
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={PaqueteElectoral} alt="Funcionarios de casilla" />
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <div className="floatLF height100 numerales">
                            <p>4</p>
                        </div>
                        <p>
                            Una vez cerrada la casilla, los funcionarios de casilla se encargan de realizar el conteo de votos e integrar el paquete electoral que será entregado al Consejo Distrital.
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}

export default EtapasJornada;